export default function getHeaderLinks(categories, appData) {
  const latestPostsLink = {
    key: 'latest_posts',
    path: '/',
    text: appData.menuLabel,
  };
  const categoryLinks = categories.map(category => ({
    key: category._id,
    path: `/categories/${category.slug}`,
    text: category.menuLabel,
  }));
  return [latestPostsLink, ...categoryLinks];
}
